import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECT_PERMISSIONS } from '../../constants.tsx';
import type { ProjectPermissions } from './types.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-project-permissions", jiraSpaEntry: "async-resource-project-permissions" */ './get-data'
	);

export const projectCreatePermissionsResource: RouteResource<ProjectPermissions | null> =
	createResource<ProjectPermissions | null>({
		type: RESOURCE_TYPE_PROJECT_PERMISSIONS,
		getKey: () => 'state',
		getDataLoader,
		maxAge: Infinity,
	});

export const useProjectCreatePermissionsResource =
	(): UseResourceHookResponse<ProjectPermissions | null> =>
		useResource<ProjectPermissions | null>(projectCreatePermissionsResource);
